import { MILLISECONDS_IN_MINUTE } from "../unit-utils/time";

export function addMinutes(oldDate: Date, minutesToAdd: number): Date {
    return new Date(oldDate.getTime() + minutesToAdd * MILLISECONDS_IN_MINUTE);
}
